// Others
import axiosClient from './axiosClient';
import { urlApiActivity } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { IActivity, IBodyCreateCallHistory, IQueryParamActivity } from '~/utils/interface/activity';

const activityApi = {
  getActivityList: (params: IQueryParamActivity) => {
    const url = urlApiActivity.getActivityList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IActivity[]>>>(url, { params });
  },
  createCallHistory: (body: IBodyCreateCallHistory) => {
    const url = urlApiActivity.createCallHistory;
    return axiosClient.post<IBaseResponse>(url, body);
  },
};

export default activityApi;
